// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__5B0Kg","copyright":"Footer_copyright__skH34"};